<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->

<template>
  <div style="height: 100%">
    <div class="inner">
      <div class="top_tab">
        <div class="tab"
             v-for="(item,index) in tab"
             :key="index"
             @click.stop="tabClick(index)"
             :class="{'activ_tab':tabActive == index}">{{item}}</div>
        <!-- <div class="tab activ_tab"></div> -->
      </div>
      <div v-if="tabActive == 1"
           style="flex: 1; display: flex;flex-direction: column; overflow: hidden;">
        <div class="top_bar">
          <div class="box"
               :class="{'active_bar':active == index}"
               v-for="(item, index) in barList"
               :key="index"
               @click.stop="barClick(index)"
               :style="'background:' + (active == index?item.bgcolor:'') + '!important;'">{{item.names}}</div>
        </div>
        <div class="title_box">
          <div class="title"
               @click.stop="goBack"
               v-if="barList[active]">
            <van-icon name="arrow-left"
                      size="16" />返回
          </div>

          <!-- <div class="title">>>{{name}}</div> -->
        </div>
        <div class="big_box"
             @scroll.passive="scroll($event)">

          <div class="list_box">
            <div class="boxs"
                 @click="toLink()">
              <div class="titles">{{lower.cate_name}}</div>
              <van-icon name="arrow"
                        color="#fff"
                        size="20" />
            </div>
          </div>
          <div class="detail">
            <div class="tItem"
                 v-for="(item, index) in list"
                 :key="index"
                 @click.stop="directionsDetail(item.instructions_id,item.type)">
              <img :src="item.type == 1 || item.type == 4 ?item.video_page:item.pt_page" />
              <a :id="'title'+ index" />
              <p>{{index + 1}}.{{item.title}}</p>
              <!-- <div v-html="item.content" style="margin-top: 0.4rem"></div> -->
            </div>
          </div>

        </div>
      </div>
      <label v-else
             style="flex: 1;">
        <div class="productList"
             v-if="!show">
          <img v-for="(item, index) in imgList"
               :key="index"
               :src="item.sources"
               @click.stop="onToDetail(item.content)" />
        </div>
        <div class="describe"
             v-else
             v-html="content"></div>
      </label>
      <down v-if="tabActive == 1 || show"></down>
    </div>
  </div>
</template>

<script>
import { getWapSeriasList, getWapList, getList } from '../api/wap'
import store from '@/store/index.js'
import down from '@/components/down'
export default {
  components: {
    down
  },
  data () {
    return {
      barList: [],
      active: 0,
      page: 1,
      page_total: 1,
      list: [],
      id: '',
      imgList: [],
      tab: ['产品介绍', '电机说明'],
      tabActive: 1,
      show: false,
      content: '',
      cate_level: '',
      name: '',
      lower: ''
    }
  },
  store,
  created () {
    if (this.$route.query.index) this.active = this.$route.query.index
    if (this.$route.query.id) this.id = this.$route.query.id
    if (this.$route.query.cate_level) this.cate_level = this.$route.query.cate_level
    this.lower = JSON.parse(localStorage.getItem('lower3'))
    this.getBar()
    this.onLoadData()
  },
  methods: {
    barClick (index) {
      this.$store.commit('check', index)
      this.$router.back(-1)
    },
    getBar () {
      getWapSeriasList({}).then(res => {
        this.barList = res.result.series_data
        this.getlist()
      })
    },
    getlist () {
      getWapList({
        page_now: this.page,
        cate_id: +this.id,
        cate_level: this.cate_level
      }).then(res => {
        if (this.page === 1) {
          this.list = res.result
        } else {
          this.list.push(...res.result)
        };
        this.page_total = res.page_total
      })
    },
    toLink () {
      this.$router.push({
        path: '/newDetailList',
        query: {
          id: this.lower.cate_id,
          cate_level: this.lower.cate_level,
          num: -2
        }
      })
    },
    goBack () {
      this.$router.back()
    },
    scroll (e) {
      let bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight
      if (bottom === 0) {
        if (this.page < this.page_total) {
          this.page++
          this.getlist()
        }
      }
    },
    onLoadData () {
      getList({ type: 3 })
        .then(res => {
          this.imgList = res.result.list
        })
    },
    tabClick (index) {
      this.tabActive = index
    },
    onToDetail (e) {
      this.content = e.replace(/<h1/g, "<h1 style='font-size: .32rem !important'")
      this.show = true
    },
    directionsDetail (id, type) {
      if (type === 2 || type === '2' || type === 5 || type === '5') {
        this.$router.push({
          path: '/videoDetail',
          query: {
            id: id
          }
        })
      } else {
        this.$router.push({
          path: '/directionsDetail',
          query: {
            id: id
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.top_tab {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #333;
}
.tab {
  flex: 1;
  text-align: center;
  font-size: 0.3rem;
  line-height: 0.8rem;
  color: #999;
}
.activ_tab {
  color: #fff;
}
.top_bar {
  padding: 0.2rem 0.5rem;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box {
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a4a4a;
  border: 1px solid #4a4a4a;
  font-size: 0.28rem;
  white-space: wrap;
  border-radius: 0.1rem;
}
.active_bar {
  color: #fff !important;
  border: none !important;
}
.title_box {
  line-height: 1rem;
  font-size: 0.28rem;
  padding-left: 0.4rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  background-color: #f3f3f3;
}
.title {
  max-width: 33.3%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
}
.big_box {
  flex: 1;
  /* background: red; */
  overflow: auto;
  background-color: #fff;
}
.big_box >>> .van-cell {
  align-items: center;
  font-size: 0.28rem !important;
  line-height: 0.4rem;
}
.productList img {
  margin-top: 0.3rem;
  width: 100%;
  border-radius: 0.16rem;
}
.productList {
  padding: 0 0.2rem;
}
.describe {
  padding: 0 0.2rem;
  font-size: 0.28rem;
}
.big_box {
  flex: 1;
  /* background: red; */
  overflow: auto;
  /* margin-top: 0.2rem; */
  background-color: #fff;
  /* padding-top: 0.2rem; */
}
.detail {
  padding: 0.2rem 0.1rem 0;
  display: flex;
  flex-wrap: wrap;
  background: #fff;
}
.tItem {
  margin-bottom: 0.3rem;
  width: 3.45rem;
  border: 1px solid rgba(188, 188, 188, 1);
  border-radius: 0.1rem;
  margin-left: 0.1rem;
  margin-right: 0.1rem;
  padding-bottom: 0.2rem;
}
.tItem p {
  color: #121212;
  font-size: 0.26rem;
  padding: 0 0.2rem 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.tItem img {
  width: 100%;
  height: 1.95rem;
  background-color: #121212;
}
.list_box {
  padding: 0.28rem 0.2rem 0;
  overflow-y: auto;
}
.boxs {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.3rem;
  min-height: 1.5rem;
  background-color: #faaa22;
  border-radius: 0.16rem;
}
.boxs .titles {
  width: 5.45rem;
  font-size: 0.42rem;
  color: #fff;
  font-weight: 500;
  line-height: 0.5rem;
}
</style>
